module.exports = __webpack_public_path__ + "img/interactive-hero-slider-mazda.4adeec1d.png";